import { H3 } from '@zooplus/ui-components';
import { useTranslation } from '../../hooks/use-translations';
import styles from './HowItWorks.module.scss';
import { Step } from './step';
import { ReactComponent as step1 } from './images/Step1Image.svg';
import { ReactComponent as step2 } from './images/Step2Image.svg';
import { ReactComponent as step3 } from './images/Step3Image.svg';
import React from 'react';

export type HowItWorksProps = {};

export const HowItWorks = ({}: HowItWorksProps) => {
  const { t } = useTranslation();
  return (
    <section>
      <H3 className={styles.title}>{t('hiw.title')}</H3>
      <div className={styles.hiwSteps}>
        <Step number={'1'} image={step1}></Step>
        <Step number={'2'} image={step2}></Step>
        <Step number={'3'} image={step3}></Step>
      </div>
    </section>
  );
};
